module.exports = __webpack_public_path__ + "static/media/6.00d9194f.png";